// 路由配置（对应 uniapp pages.json 的 9 个页面）
import Vue from 'vue';
import VueRouter from 'vue-router';
import Portal from '../views/portal/index.vue';
import Choice from '../views/choice/index.vue';
import Login from '../views/login/index.vue';
import Chat from '../views/index/index.vue';
import Report from '../views/report/index.vue';
import Assessment from '../views/assessment/index.vue';
import Evaluation from '../views/evaluation/webview.vue';
import Zixun from '../views/zixun/index.vue';
import ZixunOrder from '../views/zixun/order.vue';

Vue.use(VueRouter);

const routes = [
    { path: '/', redirect: '/portal' },
    { path: '/portal', component: Portal, meta: { title: '首页' } }, // 门户页
    { path: '/choice', component: Choice, meta: { title: '选择模式' } }, // 模式选择页（直接聊天/心理评估）
    { path: '/login', component: Login, meta: { title: '登录' } }, // 登录页
    { path: '/chat', component: Chat, meta: { title: 'AI心理陪伴' } }, // 聊天主页
    { path: '/report', component: Report, meta: { title: '咨询总结报告' } }, // 对话报告页
    { path: '/assessment', component: Assessment, meta: { title: '心理评估' } }, // 心理评估问卷页
    { path: '/evaluation', component: Evaluation, meta: { title: '量表测评' } }, // 量表测评 iframe 页
    {
        path: '/zixun',
        component: Zixun, // 心理咨询服务
        meta: { title: '心理咨询服务' },
        children: [
            {
                path: 'order',
                component: ZixunOrder,
                meta: { title: '预约登记' },
            },
        ], // 预约单
    },
    {
        path: '*',
        component: () => import('../views/NotFound.vue'),
        meta: { title: '404' },
    }, // 404
];

const router = new VueRouter({
    mode: 'history',
    routes,
    // 每次路由切换回到页面顶部（避免嵌套子路由继承父页面滚动位置）
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

// 按路由 meta.title 统一设置浏览器标签页标题
router.afterEach((to) => {
    document.title = to.meta.title || '首页';
});

export default router;
